import { Polygon } from "geojson";
import { useMemo } from "react";
import { useDrawMapStore, usePipedriveStore, useTenantInMarketStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import ITenantInMarket, { ITenantInMarketState } from "../interfaces/ITenantInMarket";
import GeometryService from "../services/geometryService";

const useTenantInMarketUpdate = (): (tenantInMarket: ITenantInMarket, tenantInMarketState: ITenantInMarketState) => Promise<void> => {
    const tenantInMarketStore = useTenantInMarketStore();
    const pipedriveStore = usePipedriveStore();
    const drawMapStore = useDrawMapStore();
    const geometryService = useMemo(() => new GeometryService(), []);

    return async (tenantInMarket: ITenantInMarket, tenantInMarketState: ITenantInMarketState): Promise<void> => {
        try {
            await tenantInMarketStore.updateTenantInMarket({
                ...tenantInMarket,
                ...tenantInMarketState,
                landAreaMin: tenantInMarketState.landAreaMin!,
                landAreaMax: tenantInMarketState.landAreaMax!,
                buildingAreaMin: tenantInMarketState.buildingAreaMin!,
                buildingAreaMax: tenantInMarketState.buildingAreaMax!,
                assignedToPipedriveUserId: tenantInMarketState.assignedToPipedriveUserId!,
                pipedriveCompanyId: await pipedriveStore.getOrCreatePipedriveOrganizationId(tenantInMarketState.pipedriveCompanyName),
                pipedriveBrokerageId: await pipedriveStore.getOrCreatePipedriveOrganizationId(tenantInMarketState.pipedriveBrokerageName),
                shape: geometryService.mapPolygonToShape(drawMapStore.result!.features[0].geometry as Polygon),
            });

            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useTenantInMarketUpdate;